import React, { useState,useEffect } from "react";
import axios from "axios"
import "./Style/Style.css";
import Swiper from "./Swiper";
import Swiper2 from "./Swiper2";
import Slider from './Slider';
import { Link } from "react-router-dom";
import pic from "./Assits/quote-img.png"
// import { getuserfunction } from "./services/Apis";
import { BACKEND_URL } from "./services/helper";



const Home = () => {
    const [userdata, setData] = useState('');
    // const [show, setShow] = useState(false);
    // console.log(userdata);

    const callUserPage = async()=>{
        try {
            let token = localStorage.getItem("userdatatoken");

            axios({
                url: `${BACKEND_URL}/getuser`,
                method: "GET",
                headers:{
                    "Content-Type": "application/json",
                   "Authorization": token
                }
            })
            .then((res)=>{
                setData(res.data.fname)
            })
            .catch((err)=>{
                // alert(err)
            })
          
            // setShow(true);
        } catch (err) {
            // console.log("there is an error",err);
            // alert(err)
        }
    }

    useEffect(()=>{
        callUserPage();
    },[]);
  
  return (
    <div>
        <Slider/>
        <section id="hero">
            <div className="contant">
                <h4>Identify Your Problems</h4>
                <h2>welcome <span style={{color:"#1a8e85"}}>{localStorage.getItem('userdatatoken') ? userdata : " to our community"}</span></h2>
                <h1>Collectively, let's illuminate destiny. </h1>
                <p>Come with us we are here to help you to reach your correct path</p>
                <button> <Link to="/contact" className="hero-btn" style={{textDecoration:"none"}}>Get Appointment</Link></button>
            </div>
          
            <div className="swiper image-slider">
               <Swiper/>
            </div>
        </section>

        <section className="feature" id="feature">
            <h2 className="heading"> How <span>We</span> Work</h2>
            <p>We're dedicated to helping you throughout your journey, following these three simple step and get appointment.</p>

            <div className="fea-base">
                <div className="fea-box">
                    <i className="fas fa-graduation-cap"></i>
                    <h3>Step-1</h3>
                    <p>First Register and Login through you ID
                    </p>
                </div>
                <div className="fea-box">
                    <i className="fas fa-certificate"></i>
                    <h3>Step-2</h3>
                    <p>Check out our Services & Fill up the Appointment Form
                    </p>
                </div>
                <div className="fea-box">
                    <i className="fas fa-award"></i>
                    <h3>Step-3</h3>
                    <p>Pay via our secure email link and get appointment.Done!
                    </p>
                </div>
            </div>
           
        </section>
        

        {/* ----------------review section------------------------------------------------- */}
        <section className="review" id="review">
            <h2 className="heading"> Our <span>Experts</span></h2>
            <div className="swiper review-slider">
                <Swiper2/>
            </div>
        </section>

        {/* -------------------Contact us---------------------------- */}
        <section className="contact" id="contact">
            <div className="fo forhome">
                <h2 className="heading"><span>Get </span> Appointment!</h2>
                <form method='POST'>
                    <div className="input-box">
                        <input type="name" placeholder="Enter Full Name"/>
                        <input type="email" placeholder="Enter Email Address"/>
                    </div>
                    <div className="input-box">
                        <input type="number"  placeholder="Enter Mobile Number"/>
                        <input type="number" placeholder="Enter Whatapp Number if Avilable"/>
                    </div>
                    <div className="input-box">
                        <input type="text"  placeholder=" Enter Expert Name"/>
                        <input type="text" placeholder="Enter Our Problem Statement"/>
                    </div>
                    <button disabled className="btn2"> Send Message</button>
                </form>
            </div>
        </section>
        <section className="student" id="student">
            <h2 className="heading">Students <span>Review</span></h2>

            <div className="box-container">
                <div className="box">
                    <img src={pic} alt="" className="quote" />
                    <p>Margadarshak provided invaluable guidance for my journey, teaching me to navigate the preparation process effectively. Exceptional experience!</p>
                    <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQYdD9FoNfY4wRYtPvNpa9u6MrOk6nwNwtRTdxZeUcJ&s' alt="" className="user" />
                    <h3>Deeksha</h3>
                    <div className="stars">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star-half-alt"></i>
                    </div>
                </div>
                <div className="box">
                    <img src={pic} alt="" className="quote" />
                    <p>I'm Sejal, and my experience with Margadarshak was fantastic. I learned to navigate the preparation journey effectively.</p>
                    <img src='https://www.w3schools.com/w3images/avatar6.png' alt="" className="user" />
                    <h3>sejal</h3>
                    <div className="stars">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star-half-alt"></i>
                    </div>
                </div>
                <div className="box">
                    <img src={pic} alt="" className="quote" />
                    <p>I'm Romil, and Margadarshak was an amazing experience. It taught me to navigate the preparation journey, a significant improvement from before.</p>
                    <img src='https://www.w3schools.com/w3images/avatar2.png' alt="" className="user" />
                    <h3>Romil</h3>
                    <div className="stars">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star-half-alt"></i>
                    </div>
                </div>
            </div>
        </section>
    </div>  
  );
};

export default Home;
